import { render, staticRenderFns } from "./AdElement.vue?vue&type=template&id=f53a2aa2&scoped=true"
import script from "./AdElement.vue?vue&type=script&lang=js"
export * from "./AdElement.vue?vue&type=script&lang=js"
import style0 from "./AdElement.vue?vue&type=style&index=0&id=f53a2aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53a2aa2",
  null
  
)

export default component.exports